<template>
    <div class="af-app af-register">
        <RegisterForm />
    </div>
</template>

<script>
    import RegisterForm from './components/RegisterForm.vue';

    export default {
        name: 'App',
        components: {
            RegisterForm,
        },
    };
</script>
